import * as React from 'react';

import type {ClosedLeadEmailAutomation as ClosedLeadEmailAutomationFragment} from 'nutshell-graphql-types';

import type {EmailListType} from '../editor/closed-lead-email-list-editor';

import {SalesAutomationCard} from './sales-automation-card';

import styles from './sales-automation-card-email.module.css';

type Props = {
    parentId: string;
    emailAutomation: ClosedLeadEmailAutomationFragment;
    type: EmailListType;
};

/*
 * Component that represents a single step template card on the sales process.
 */
export class ClosedLeadEmailAutomationCard extends React.PureComponent<Props> {
    render() {
        const {id} = this.props.emailAutomation;
        const image =
            this.props.type === 'MAILCHIMP'
                ? '/include/images/integration-logos/mailchimp-freddy.png'
                : '/include/images/integration-logos/constant-contact.png';

        return (
            <SalesAutomationCard
                parentId={this.props.parentId}
                type={
                    this.props.type === 'MAILCHIMP'
                        ? 'closedLeadMailChimpSubscriptions'
                        : 'closedLeadConstantContactSubscriptions'
                }
                isHidden={false} // Can't drag cards or outcomes around no hidden state
                entityId={id}
            >
                <div className={styles['closed-lead-relative-container']}>
                    <div className={styles['card-border']} />
                    <img src={image} className={styles['mailchimp-logo']} />
                    {this.getCardBody()}
                </div>
            </SalesAutomationCard>
        );
    }

    getCardBody() {
        const {emailList} = this.props.emailAutomation;

        if (!emailList) {
            return (
                <div className={styles['title-container']}>
                    <div className={styles.title}>
                        <span className={styles['missing-list']}>
                            Oh no! We couldn’t find the list.
                        </span>
                    </div>
                </div>
            );
        }

        return (
            <div className={styles['title-container']}>
                <div className={styles.subtitle}>
                    <span>Add to list: </span>
                </div>
                <div className={styles['list-name']}>
                    <span>{emailList.name}</span>
                </div>
            </div>
        );
    }
}
